<script lang="ts">
  import Header from "./lib/components/Header.svelte";
  import Hero from "./lib/components/Hero.svelte";
  import SubjectsBar from "./lib/components/SubjectsBar.svelte";
  import HowItWorks from "./lib/components/HowItWorks.svelte";
  import Features from "./lib/components/Features.svelte";
  import AdaptiveDemo from "./lib/components/AdaptiveDemo.svelte";
  import Solutions from "./lib/components/Solutions.svelte";
  import UseCases from "./lib/components/UseCases.svelte";
  import Market from "./lib/components/Market.svelte";
  import Pricing from "./lib/components/Pricing.svelte";
  import FAQ from "./lib/components/FAQ.svelte";
  import CTA from "./lib/components/CTA.svelte";
  import Footer from "./lib/components/Footer.svelte";
</script>

<Header />
<main>
  <Hero />
  <SubjectsBar />
  <HowItWorks />
  <Features />
  <AdaptiveDemo />
  <Solutions />
  <UseCases />
  <Market />
  <Pricing />
  <FAQ />
  <CTA />
</main>
<Footer />
